module.exports = __webpack_public_path__ + "static/map-fe76fd59489f5ccc1e3afe566856c59a.svg";